import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ndms-validation-messages',
  templateUrl: './ndms-validation-messages.component.html',
  styleUrls: ['./ndms-validation-messages.component.scss']
})
export class NdmsValidationMessagesComponent implements OnInit {
  @Input() errors: any;
  @Input() label: string;
  
  constructor() { }

  ngOnInit() {
  }

  keys() {
    return Object.keys(this.errors || {});
  }

}
